
/**
 * Gère les filtres concernant les certifications d'un contrat d'achat
 */
export class StatutFiltreCertification {
    /**
     * Rechercher les certifiés et les non certifiés
     */
    public static readonly Tous = { label: 'Tous', valeur: 0 };

    /**
     * Recherche uniquement les certifiés
     */
    public static readonly Certifie = { label: 'Oui', valeur: 1 };

    /**
     * Recherche les non certifiés
     */
    public static readonly NonCertifie = { label: 'Non', valeur: 2 };

    /**
     * Obtenir la liste des filtres certification
     * @returns 
     */
    public static getOptions(): Array<{ label: string; valeur: number }> {
        return [
            this.Tous,
            this.Certifie,
            this.NonCertifie
        ];
    }
}
